import { render, staticRenderFns } from "./AccidentEntity.vue?vue&type=template&id=2dd19ae8&"
import script from "./AccidentEntity.vue?vue&type=script&lang=js&"
export * from "./AccidentEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dd19ae8')) {
      api.createRecord('2dd19ae8', component.options)
    } else {
      api.reload('2dd19ae8', component.options)
    }
    module.hot.accept("./AccidentEntity.vue?vue&type=template&id=2dd19ae8&", function () {
      api.rerender('2dd19ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccidentEntity.vue"
export default component.exports